import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

// MUI HighlightOff icon
const fallbackImg = 'data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24"><path fill="%23b1b1b1" d="M 14.59 8 L 12 10.59 L 9.41 8 L 8 9.41 L 10.59 12 L 8 14.59 L 9.41 16 L 12 13.41 L 14.59 16 L 16 14.59 L 13.41 12 L 16 9.41 L 14.59 8 Z M 12 2 C 6.47 2 2 6.47 2 12 s 4.47 10 10 10 s 10 -4.47 10 -10 S 17.53 2 12 2 Z m 0 18 c -4.41 0 -8 -3.59 -8 -8 s 3.59 -8 8 -8 s 8 3.59 8 8 s -3.59 8 -8 8 Z"></path></svg>';

const ImgWithRetry = ({ classes, retryCount = 0, ...rest }) => {
  const [isFallback, setIsFallback] = useState(false);
  let retries = 0;
  const onImgError = e => {
    if (retries < retryCount) {
      retries++;
      console.log(`Img error, retrying... (attempt ${retries})`);
      const src = e.target.src;
      e.target.src = src.includes('?') ? `${src}&retries=${retries}` : `${src}?retries=${retries}`; // append retries as a query string to force reload and avoid broswer caching
    } else {
      console.log('All retries failed, switching to fallback img');
      setIsFallback(true);
      e.target.src = fallbackImg;
    }
  }

  return (
    isFallback 
      ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
          <img {...rest} onError={onImgError} className={classNames(classes.maxSize, rest.className)}/>
        </div>
      : <img {...rest} onError={onImgError} />
  );
};

const styles = theme => ({
  maxSize: {
    maxWidth: 50,
    maxHeight: 50
  }
});

export default withStyles(styles)(ImgWithRetry);